import axios from "axios";
import { env_url, env_faq_url } from "../../serverEnv";

const deleteCategoryItemApi = (token: string, id: number) => {
  return axios.delete(`${env_faq_url}/categories/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// const postNewCategoryItemApi = (token: string, name: string, order:number) => {
//   return (
//     axios.post(
//       `${env_faq_url}/categories`,
//       {
//         "name": name,
//         "order": order
//       },
//       {
//         headers: {
//           "Authorization": `Bearer ${token}`,
//         }
//       }
//     )
//   )
// }

function* postNewCategoryItemApi(token: string, name: string, order: number) {
  try {
    const result = yield axios.post(
      `${env_faq_url}/categories`,
      {
        name: name,
        order: order,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result;
  } catch (e) {
    console.log("error", e.message);
  }
}

function* getCategoriesApiAfterPost(token: string) {
  const result = yield axios.get(`${env_faq_url}/categories`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return result;
}

const updateCategoryItemApi = (
  token: string,
  name: string,
  order: number,
  id: number
) => {
  return axios.put(
    `${env_faq_url}/categories/${id}`,
    {
      name: name,
      order: order,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export {
  deleteCategoryItemApi,
  postNewCategoryItemApi,
  updateCategoryItemApi,
  getCategoriesApiAfterPost,
};
